export default __webpack_public_path__ + "static/media/background.802de12c.svg";